import z from 'app/common/z';
import Errors, { resourceNames } from 'app/errors';
import { fetchJson } from 'app/common/fetch';

const Data = {
  sharedZap(id) {
    return fetchJson(`${z.cfg.api}/recipes/guided/${id}`).catch(response => {
      throw new Errors.DataGetError({
        resource: resourceNames.sharedZap,
        response,
      });
    });
  },
};

export default Data;
